import React from 'react'
import styled from 'styled-components'
import { PropertyTags as LibPropertyTags, TagEditor } from '@popety-io/ui'
import { useLandTags } from '../../contexts/LandTagsContext'

const TagsContainer = styled.div`
  position: relative;
  display: inline-block;
`

export const PropertyTags: React.FC = () => {
  const {
    tags,
    allTags,
    loading,
    error,
    isEditing,
    setIsEditing,
    addTag,
    removeTag,
    createNewTag,
    loadAllTags,
  } = useLandTags()

  return (
    <TagsContainer>
      <LibPropertyTags
        tags={tags}
        loading={loading}
        error={error}
        isEditing={isEditing}
        onEditClick={() => setIsEditing(true)}
      />

      {isEditing && (
        <TagEditor
          tags={tags}
          allTags={allTags}
          loading={loading}
          error={error}
          onClose={() => setIsEditing(false)}
          onAddTag={addTag}
          onRemoveTag={removeTag}
          onCreateTag={createNewTag}
          onLoadAllTags={loadAllTags}
        />
      )}
    </TagsContainer>
  )
}
